import { axiosInstance } from '../../App';
//axios.defaults.baseURL="http://localhost:8080"

import { AppointmentsDTO } from '../../interface/interface';

export function getAppointmentList( initialDateTime: Date, finalDateTime: Date, professionalId: number, showAppointments: number, type: number){
    return axiosInstance.get('/api/secured/appointment/getAppointmentList',{
        params: {
            initialDateTime,
            finalDateTime,
            professionalId,
            showAppointments,
            type
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function openNotes(params: { patientCareQueue: number, sessionId?: string }) {
    return axiosInstance.get('/api/secured/appointment/openNotes', {
        params: {
            patientCareQueue: params.patientCareQueue,
            deviceUUID: localStorage.getItem('uuid') || '',
            sessionId: params.sessionId || '',
        }
    })
}

export function openButtons(data: AppointmentsDTO, ) {
    data.deviceUUID = localStorage.getItem('uuid') || '';
    return axiosInstance.post(`/api/secured/appointment/openButtons`, data, {
        params: {
        }
    })
}

export function getAppointmentListSpeciality(initialDateTime: Date, finalDateTime: Date, specialityId: number, showAppointments: number, type: number){
    return axiosInstance.get('/api/secured/appointment/getAppointmentListSpeciality',{
        params: {
            initialDateTime,
            finalDateTime,
            specialityId,
            showAppointments,
            type
        }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        console.error(error);
        throw error;
    });
}

export function useAppointmentReactService() {
  return {
    getAppointmentList,
    openNotes,
    openButtons,
    getAppointmentListSpeciality,
  }
}
